import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContactsState, contactsAdapter } from './contacts.reducer';

// Create a feature selector for the 'contacts' feature
export const selectContactsState = createFeatureSelector<ContactsState>('contacts');

// Create a selector to get the contacts from the state
export const selectContacts = createSelector(
  selectContactsState,
  (state) => contactsAdapter.getSelectors().selectAll(state) // state might be undefined if feature not loaded yet, but usually handled by NgRx
);

export const selectInstructorsContacts = createSelector(
  selectContacts,
  (allContacts) => allContacts.filter((contact) => contact.type == 'instructor' || contact.type == 'owner')
);

// Create a selector to get the loading status
export const isCreateContactProcessing = createSelector(selectContactsState, (state) => ({ status: state.createNewContactProcess.status, error: state.createNewContactProcess.error, lastCreatedContact: state.createNewContactProcess.lastCreatedContact }));

// Create a selector to get the error status
export const isContactsLoadingError = createSelector(selectContactsState, (state) => state.error);
